<template>
  <div>
    <async-linear-progress :task="task" />
    <message v-if="!isLoading && !numItems">
      <slot />
    </message>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AsyncLinearProgress from '../loading/AsyncLinearProgress.vue';
import Message from '../message/Message.vue';

interface Data {
  isLoading: boolean,
}

export default defineComponent({
  components: { AsyncLinearProgress, Message },
  props: {
    task: Promise,
    numItems: {
      type: Number,
      default: 0,
    },
  },
  data(): Data {
    return {
      isLoading: false,
    };
  },
  watch: {
    task: {
      handler(task?: Promise<any>) {
        this.isLoading = false;
        if (!task) return;
        this.isLoading = true;
        task.finally(() => {
          this.isLoading = false;
        });
      },
      immediate: true,
    },
  },
});
</script>
